require('./hireCardVirtualOnlyDebitStep1.scss');
// @ vendors
const PropTypes = require('prop-types');
const React = require('react');

// @helpers
const { FormattedText, formatText } = require('core/i18n').i18n;
const { getEmail } = require('utilities/personalDataHelper');

// @ components
const { HireInformation } = require('components/hire/hireInformation/hireInformation');
const HiringProductInformation = require('components/hiringProductInformation/hiringProductInformation');
const PreContractualMailInfo = require('components/contactCenter/preContractualMailInfo/preContractualMailInfo');
const { OKCheckbox } = require('commonsComponents/OKCheckbox');

// @constants
const { FIRST_STEP } = require('constants/index');
const getCardsPreContractPdfData = require('constants/cardsPreContractualsPdf');
const { VIRTUAL_DEBIT_CARD_PRODUCT_ALIAS,
    PRODUCT_HIRING_COMPONENT_ID } = require('constants/hiringProductInformation');
const { GC } = require('constants/flagBasedFeatures');

class HireCardVirtualOnlyDebitStep1 extends React.Component {

    componentDidMount() {
        const {
            requestPDFMerge,
            setTermsAndCondsText,
        } = this.props;

        if (!__CONTACT_CENTER__) {
            const pdfurls = getCardsPreContractPdfData()['virtual_debit'].preContractPdfLink;
            const product = {
                type: '506',
                subtype: '012',
                standard: '0000001'
            };
            requestPDFMerge(pdfurls, [product]);
        } else {
            setTermsAndCondsText('hireCardVirtualOnlyDebit-hireCardVirtualOnlyDebit_step3CheckboxText');
        }
    }

    buildLegalConfirmationSection() {
        if (!__CONTACT_CENTER__) {
            return null;
        }

        const { immHireInformation, immHiringProductInformation, gestorCrossEnabled } = this.props
        const information = gestorCrossEnabled ? immHiringProductInformation.get('cmsResponse') : immHireInformation.get('information');
        if (!__CONTACT_CENTER__ || !information) {
            return null;
        }

        const {
            contractName,
            handleAgreementCheckboxChange,
            immHireCardVirtualOnlyDebit,
            immPreContractualMail,
            immProfileFields,
            requestProfile,
            sendMailParams,
            sendPreContractualMail
        } = this.props;

        const clientEmail = getEmail(immProfileFields);
        const profileError = immProfileFields.get('error');
        const hasBeenEmailSent = immPreContractualMail.get('mailSent');
        const immStep = immHireCardVirtualOnlyDebit.getIn(['steps', FIRST_STEP]);
        const agreementLabel = <FormattedText value="hireCardVirtualOnlyDebit-hireCardVirtualOnlyDebit_step3CheckboxText" />;
        const agreementChecked = immStep.get('agreementChecked');
        const agreementErrorVisible = immStep.get('agreementIsDirty') && !immStep.get('agreementChecked');
        const agreementErrorMsg = formatText('hireCardVirtualOnlyDebit-hireCardVirtualOnlyDebit_step3CheckboxErrorMsg');

        return (
            <section className="hire-card-virtual-only-debit-step-one__legal-confirmation-section">
                <PreContractualMailInfo
                    contractName={contractName}
                    email={clientEmail}
                    preContractualMail={immPreContractualMail}
                    profileError={profileError}
                    requestProfile={requestProfile}
                    sendEmail={sendPreContractualMail}
                    sendMailParams={sendMailParams}
                />
                <div className="hire-card-virtual-only-debit-step-one__checkbox-container">
                    <OKCheckbox
                        disabled={!hasBeenEmailSent}
                        errorMessage={agreementErrorMsg}
                        errorState={agreementErrorVisible}
                        idName="hireCardOpenDebitAgreementCheckbox"
                        label={agreementLabel}
                        onChange={handleAgreementCheckboxChange}
                        value={agreementChecked}
                    />
                </div>
            </section>
        );

    }

    render() {
        const { immHireInformation, gestorCrossEnabled, flagBasedFeatures } = this.props;
        const legalConfirmationSection = this.buildLegalConfirmationSection();
        let productInformationComponent;
        if (gestorCrossEnabled && flagBasedFeatures.get(GC)) {
            productInformationComponent = (
                <React.Fragment>
                    <HiringProductInformation
                        productAlias={VIRTUAL_DEBIT_CARD_PRODUCT_ALIAS}
                        productComponentId={PRODUCT_HIRING_COMPONENT_ID}
                    />
                    {legalConfirmationSection}
                </React.Fragment>
            )
        } else {
            productInformationComponent = (
                <article className="hire-card-virtual-only-debit__step-one">
                    <FormattedText
                        className="hire-card-virtual-only-debit__step-title"
                        value="hireCardVirtualOnlyDebit-hireCardVirtualOnlyDebit_step1Title"
                    />
                    <HireInformation
                        hireCmsKey={this.props.hireCmsKey}
                        immHireInformation={immHireInformation}
                    />
                    {legalConfirmationSection}
                </article>
            )
        }
        return (
            <div>
                {productInformationComponent}
            </div>
        );
    }
}

HireCardVirtualOnlyDebitStep1.propTypes = {
    contractName: PropTypes.string,
    flagBasedFeatures: PropTypes.object.isRequired,
    gestorCrossEnabled: PropTypes.bool,
    handleAgreementCheckboxChange: PropTypes.func,
    hireCmsKey: PropTypes.string.isRequired,
    immHireCardVirtualOnlyDebit: PropTypes.object,
    immHireInformation: PropTypes.object.isRequired,
    immHiringProductInformation: PropTypes.object.isRequired,
    immPreContractualMail: PropTypes.object,
    immProfileFields: PropTypes.object,
    requestPDFMerge: PropTypes.func.isRequired,
    requestProfile: PropTypes.func,
    sendMailParams: PropTypes.object,
    sendPreContractualMail: PropTypes.func,
    setTermsAndCondsText: PropTypes.func.isRequired,
};

module.exports = HireCardVirtualOnlyDebitStep1;
